import React, { useState } from "react";
import {
  Col,
  Row,
  Container,
  Nav,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";

import offer3 from "../../assets/images/offers/subscribe.svg";
import EmailInput from "./EmailInput";
const Subscribe = () => {
  return (
    <React.Fragment>
      <section className="bg-light  gaps">
        <Container fluid className="bg-light">
          <Row>
            <div className="subscribe-div">
              <Col md={6}>
                <span
                  style={{ display: "block", paddingBottom: "20px" }}
                  className="h1"
                >
                  Catch the Weekly Scoop!
                </span>
                <span className="body-regular subscribe-text">
                  Stay updated with the freshest catches, exclusive deals, and{" "}
                  seafood recipes delivered straight to your inbox
                </span>
                <div className="form=group">
                  <EmailInput />
                </div>
              </Col>
              <Col md={6}></Col>
            </div>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Subscribe;
